<div class="container mx-auto">
<div class="card">
  <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">
    {{ "customer.profile.masterData" | translate }}
  </h1>

  @if (shouldShowSummaryCard()) {
    <section class="mt-5 border border-gray-200 rounded-md p-4">
      <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5 text-sm">
        <div>
          <h2 class="font-bold md:text-lg text-sm mb-2">
            {{ "customer.profile.address" | translate }}
          </h2>
          @if (customerFullName()) {
            <p>{{ customerFullName() }}</p>
          }
          @let addressLines = getSummaryAddressLines();
          @if (addressLines.length) {
            @for (addressLine of addressLines; track addressLine) {
              <p>{{ addressLine }}</p>
            }
          } @else {
            <p>-</p>
          }
        </div>

        <div>
          <h2 class="font-bold md:text-lg text-sm mb-2">
            {{ "customer.profile.customerInfo" | translate }}
          </h2>
          <p>{{ "customer.profile.customerNo" | translate }}: {{ getCustomerNumber() }}</p>
          <p>{{ "customer.profile.mandant" | translate }}: {{ getMandant() }}</p>
        </div>

        <div>
          <h2 class="font-bold md:text-lg text-sm mb-2">
            {{ "customer.profile.paymentTerms" | translate }}
          </h2>
          @let daysNet = getPaymentTermsDaysNet();
          @if (daysNet !== null) {
            <p>{{ "customer.profile.daysNet" | translate: { daysNet: daysNet } }}</p>
          } @else {
            <p>-</p>
          }
        </div>

        <div>
          <h2 class="font-bold md:text-lg text-sm mb-2">
            {{ "customer.profile.contact" | translate }}
          </h2>
          @let primaryContactLines = getPrimaryContactLines();
          @if (primaryContactLines.length) {
            @for (primaryContactLine of primaryContactLines; track primaryContactLine) {
              <p>{{ primaryContactLine }}</p>
            }
          } @else {
            <p>-</p>
          }
        </div>
      </div>
    </section>
  } @else if (isMasterDataLoading() || isContactsLoading()) {
    <section class="mt-5 border border-gray-200 rounded-md p-4">
      <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5">
        @for (card of [1, 2, 3, 4]; track card) {
          <div class="space-y-3">
            <p-skeleton width="60%" height="1.25rem"></p-skeleton>
            <p-skeleton width="90%" height="1rem"></p-skeleton>
            <p-skeleton width="75%" height="1rem"></p-skeleton>
            <p-skeleton width="50%" height="1rem"></p-skeleton>
          </div>
        }
      </div>
    </section>
  }

  @if (!isCompanySettingsLoading()) {
    <section class="mt-5 border border-gray-200 rounded-md p-4">
      <h2 class="font-bold md:text-lg text-sm mb-4">
        {{ "customer.profile.companySettings.title" | translate }}
      </h2>
      <div class="grid lg:grid-cols-2 grid-cols-1 gap-6 text-sm">
        <div class="flex flex-col">
          <h3 class="font-semibold mb-2">
            {{ 'ElectronicInvoice' | FunctionCategory | translate }}
          </h3>
          @if (canEditAll()) {
            <p-select
              [options]="listedContacts"
              optionLabel="recipientLabel"
              optionValue="contactNumber"
              [filter]="true"
              filterBy="recipientLabel"
              [showClear]="true"
              appendTo="body"
              styleClass="w-full"
              [ngModel]="selectedInvoiceRecipientContactNumber"
              (ngModelChange)="onInvoiceRecipientChange($event)"
              [placeholder]="'customer.profile.companySettings.selectRecipient' | translate">
            </p-select>

            @if (selectedInvoiceRecipientContactNumber != null) {
              <div class="mt-3 space-y-3">
                @for (contactFunction of getElectronicInvoiceFunctions(); track getFunctionKey(contactFunction)) {
                  <div class="grid min-w-0 grid-cols-[minmax(0,1fr)_auto] items-start gap-3">
                    <span class="min-w-0 leading-5 [overflow-wrap:anywhere]">
                      {{ getFunctionDisplayName(contactFunction) }}
                    </span>
                    <p-toggleswitch
                      class="justify-self-end"
                      [ngModel]="isInvoiceFunctionSelected(contactFunction)"
                      [disabled]="isSavingElectronicInvoiceRecipient()"
                      (ngModelChange)="setInvoiceFunctionSelected(contactFunction, $event)">
                    </p-toggleswitch>
                  </div>
                }
              </div>

              <div class="mt-auto pt-3">
                <p-button
                  [label]="'saveButton' | translate"
                  icon="pi pi-check"
                  [loading]="isSavingElectronicInvoiceRecipient()"
                  [disabled]="isSavingElectronicInvoiceRecipient()"
                  (onClick)="saveElectronicInvoiceRecipient()">
                </p-button>
              </div>
            }
          } @else {
            <p>
              {{
                getContactDisplayNameByContactNumber(companySettings()?.electronicInvoiceRecipientContactNumber)
                  || ("customer.profile.companySettings.none" | translate)
              }}
            </p>
          }
        </div>

        @if (isAcpUser() || canManageCustomerLogo()) {
          <div class="flex flex-col gap-6">
            @if (isAcpUser()) {
              <div>
                <h3 class="font-semibold mb-2">
                  {{ 'Reminder' | FunctionCategory | translate }}
                </h3>
                <div class="flex items-start gap-3">
                  <p-multiselect
                    class="min-w-0 flex-1"
                    [options]="listedContacts"
                    optionLabel="recipientLabel"
                    optionValue="contactNumber"
                    [filter]="true"
                    filterBy="recipientLabel"
                    appendTo="body"
                    styleClass="w-full"
                    [(ngModel)]="selectedReminderRecipientContactNumbers"
                    [placeholder]="'customer.profile.companySettings.selectRecipients' | translate">
                  </p-multiselect>

                  <p-button
                    styleClass="whitespace-nowrap"
                    [label]="'saveButton' | translate"
                    icon="pi pi-check"
                    [loading]="isSavingReminderRecipients()"
                    [disabled]="isSavingReminderRecipients()"
                    (onClick)="saveReminderRecipients()">
                  </p-button>
                </div>
              </div>
            }

            @if (canManageCustomerLogo()) {
              <gate-customer-logo-settings />
            }
          </div>
        }
      </div>
    </section>
  }

  @if (contactsLoaded || isContactsLoading()) {
    <section class="mt-6">
      <p-table
          #masterDataTable
          [value]="filteredContacts()"
          [showLoader]="false"
          [loading]="isContactsLoading()"
          dataKey="id"
          [paginator]="true"
          [rows]="itemsPerPage"
          [rowsPerPageOptions]="[10, 25, 50]"
          [currentPageReportTemplate]="'primeng.currentPageReportTemplate' | translate"
          [showCurrentPageReport]="true"
          [resizableColumns]="true"
          columnResizeMode="expand"
          [scrollable]="true"
          [first]="currentPageFirst()"
          (onPage)="onPageChange($event)"
          (onFilter)="onFilter($event)"
          class="md:text-base text-sm"
          gateTableStateKey="masterDataTableState"
          [gateTablePersistence]="tablePersistence"
         >
          <ng-template #loadingbody>
            <ng-container *ngTemplateOutlet="contactTableLoadingRows"></ng-container>
          </ng-template>

          <ng-template #caption>
            <div class="flex flex-col gap-4 md:text-base text-sm xl:flex-row xl:items-center xl:justify-between">
              <div class="min-w-0">
                <p class="font-['Apex_Rounded_Medium'] text-sm">
                  {{ "customer.profile.contactsAndFunctions" | translate }}
                </p>
              </div>
              <div class="w-full xl:w-auto">
                <div class="flex flex-col gap-3 xl:flex-row xl:flex-wrap xl:items-center xl:justify-end">
                   @if (hasActiveFilterOrSearch()) {
                  <div class="w-full md:ml-auto md:w-1/2 xl:ml-0 xl:w-auto xl:flex-none">
                    <p-button
                      [label]="'clearFilter' | translate"
                      severity="danger"
                      icon="pi pi-filter-slash"
                      (click)="clearFilter(masterDataTable)"
                      styleClass="w-full whitespace-nowrap xl:w-auto md:text-base text-sm" />
                  </div>
                  }
                  <div class="flex flex-col gap-3 md:flex-row md:gap-3 xl:contents">
                    <div class="flex w-full items-center justify-start gap-2 md:w-1/2 xl:w-auto xl:flex-none">
                      <p-toggleswitch
                        [ngModel]="assignedFunctionsOnly()"
                        (ngModelChange)="onAssignedFunctionsOnlyToggle($event)">
                        <ng-template #handle let-checked="checked">
                          <i [class]="checked ? 'pi pi-check !text-xs' : 'pi pi-times !text-xs'"></i>
                        </ng-template>
                      </p-toggleswitch>
                      <label class="text-left text-sm font-medium leading-5">
                        {{ "customer.profile.assignedFunctionsOnly" | translate }}
                      </label>
                    </div>

                    <div class="w-full md:w-1/2 xl:w-auto xl:min-w-64 xl:flex-1">
                      <div class="flex">
                        <p-iconfield iconPosition="left" class="w-full">
                          <p-inputicon>
                            <i class="pi pi-search"></i>
                          </p-inputicon>
                          <input
                            pInputText
                            type="text"
                            [ngModel]="searchValue()"
                            (ngModelChange)="onSearchChange($event)"
                            [placeholder]="'searchPlaceholder' | translate"
                            class="w-full min-w-0 md:text-base text-sm" />
                        </p-iconfield>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template #header>
            <tr>
              <th pResizableColumn pSortableColumn="sortName">
                {{ "customer.profile.contact" | translate }}
                <p-sortIcon field="sortName" />
              </th>
              <th pResizableColumn>{{ "customer.profile.details" | translate }}</th>
              <th pResizableColumn>
                {{ "customer.profile.assignedFunctions" | translate }}
                <p-columnFilter
                  field="contactFunctionKeys"
                  matchMode="contains"
                  display="menu"
                  [showOperator]="false"
                  [showMatchModes]="false"
                  [showAddButton]="false"
                  [hideOnClear]="true"
                  [showApplyButton]="false"
                  #functionFilter>
                  <ng-template #filtericon let-hasFilter="hasFilter">
                    <gate-table-filter-icon
                      [hasFilter]="hasFilter"
                      [table]="masterDataTable"
                      field="contactFunctionKeys"
                      [options]="contactFunctionFilterOptions" />
                  </ng-template>
                  <ng-template #filter let-value let-filter="filterCallback">
                    <p-select
                      [options]="contactFunctionFilterOptions"
                      optionLabel="key"
                      optionValue="value"
                      [ngModel]="value"
                      (onChange)="filter($event.value); functionFilter.hide()"
                      appendTo="body"
                      panelStyleClass="contact-function-filter-panel"
                      [placeholder]="'customer.profile.assignedFunctions' | translate">
                      <ng-template #selectedItem let-option>
                        @if (option) {
                          <span class="block min-w-0 truncate">
                            {{ option.key }} ({{ option.category | FunctionCategory | translate }})
                          </span>
                        }
                      </ng-template>
                      <ng-template #item let-option>
                        <span class="block max-w-md whitespace-normal leading-5 [overflow-wrap:anywhere]">
                          {{ option.key }} ({{ option.category | FunctionCategory | translate }})
                        </span>
                      </ng-template>
                    </p-select>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th pResizableColumn pFrozenColumn alignFrozen="right">
                {{ "customer.profile.actions" | translate }}
              </th>
            </tr>
          </ng-template>

          <ng-template #body let-contact>
            <tr>
              <td>
                <span class="p-column-title">{{ "customer.profile.contact" | translate }}</span>
                <span class="truncate table-col-primary">{{ getContactDisplayName(contact, contact.salutation | salutation | translate) }}</span>
              </td>

              <td>
                <span class="p-column-title">{{ "customer.profile.details" | translate }}</span>
                <div class="space-y-1 text-sm">
                  @if (contact.telephoneNumber) {
                    <p class="flex items-center gap-2">
                      <i class="pi pi-phone text-xs"></i>
                      <span>{{ contact.telephoneNumber }}</span>
                    </p>
                  }
                  @if (contact.mobileNumber) {
                    <p class="flex items-center gap-2">
                      <i class="pi pi-mobile text-xs"></i>
                      <span>{{ contact.mobileNumber }}</span>
                    </p>
                  }
                  @if (contact.notifyAddress || contact.emailAddress) {
                    <p class="flex items-center gap-2">
                      <i class="pi pi-envelope text-xs"></i>
                      <span>{{ contact.notifyAddress || contact.emailAddress }}</span>
                    </p>
                  }
                </div>
              </td>

              <td>
                <span class="p-column-title">{{ "customer.profile.assignedFunctions" | translate }}</span>
                @let activeFunctionCategories = getActiveFunctionCategories(contact);
                @if (activeFunctionCategories.length) {
                  <div class="flex flex-wrap gap-2">
                    @for (category of activeFunctionCategories; track getCategoryValue(category) || $index) {
                      <span
                        class="inline-flex w-fit max-w-full items-center gap-1.5 rounded-[5px] border border-[var(--border-color)] bg-[color-mix(in_srgb,var(--secondary-idle),var(--card-background)_94%)] px-2.5 py-1.5 text-xs leading-4 text-[var(--text-color)]"
                        [pTooltip]="getFunctionCodes(category)"
                        tooltipPosition="top">
                        <span class="min-w-0 truncate">{{ getFunctionCodes(category) }}</span>
                      </span>
                    }
                  </div>
                } @else {
                  <span class="text-sm text-secondary">{{ "customer.profile.noAssignedFunctions" | translate }}</span>
                }
              </td>

              <td class="action-td" pFrozenColumn alignFrozen="right">
                @if (canEditContact(contact)) {
                  <button
                    class="icon-with-circle"
                    [pTooltip]="'customer.profile.editFunctions' | translate"
                    tooltipPosition="top"
                    (click)="openEditDialog(contact)">
                    <i class="pi pi-pen-to-square"></i>
                  </button>
                }
              </td>
            </tr>
          </ng-template>

          <ng-template #emptymessage>
            <tr class="emptymessage">
              <td colspan="4">
                <div class="text-center">
                  <i class="pi pi-exclamation-triangle text-yellow-500" style="font-size: 2rem"></i>
                  <p>{{ "customer.profile.noRecordsFound" | translate }}</p>
                </div>
              </td>
            </tr>
          </ng-template>
      </p-table>
    </section>
  }
</div>
</div>

<ng-template #masterDataSkeleton>
  <p-skeleton width="14rem" height="2rem"></p-skeleton>

  <section class="mt-5 border border-gray-200 rounded-md p-4">
    <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-5">
      @for (card of [1, 2, 3, 4]; track card) {
        <div class="space-y-3">
          <p-skeleton width="60%" height="1.25rem"></p-skeleton>
          <p-skeleton width="90%" height="1rem"></p-skeleton>
          <p-skeleton width="75%" height="1rem"></p-skeleton>
          <p-skeleton width="50%" height="1rem"></p-skeleton>
        </div>
      }
    </div>
  </section>

  <section class="mt-6">
    <gate-generic-table-skeleton
      [columns]="contactTableSkeletonColumns"
      [rows]="5"
      [showCaption]="true"
      captionWidth="12rem"
      [captionActionCount]="2"
      [showActions]="true"
      actionType="circle">
    </gate-generic-table-skeleton>
  </section>
</ng-template>

<ng-template #contactTableLoadingRows>
  @for (row of [1, 2, 3, 4, 5]; track row) {
    <tr>
      <td><p-skeleton width="70%" height="1rem"></p-skeleton></td>
      <td>
        <div class="space-y-2">
          <p-skeleton width="55%" height="1rem"></p-skeleton>
          <p-skeleton width="80%" height="1rem"></p-skeleton>
        </div>
      </td>
      <td>
        <div class="flex flex-wrap gap-2">
          <p-skeleton width="12rem" height="2rem"></p-skeleton>
          <p-skeleton width="8rem" height="2rem"></p-skeleton>
        </div>
      </td>
      <td class="action-td" pFrozenColumn alignFrozen="right">
        <p-skeleton shape="circle" size="2rem"></p-skeleton>
      </td>
    </tr>
  }
</ng-template>

<p-dialog
  [(visible)]="editDialogVisible"
  [header]="'customer.profile.editFunctions' | translate"
  [modal]="true"
  [closable]="!isSavingContactFunctions"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-[92vw] max-w-3xl">
  @if (selectedContact) {
    <div class="space-y-5">
      <div>
        <h2 class="font-bold text-lg">{{ selectedContact.firstName }} {{ selectedContact.lastName }}</h2>
        <p class="text-sm text-gray-600">{{ selectedContact.emailAddress }}</p>
      </div>

      <div class="space-y-4">
        @for (category of dialogFunctionCategories; track getCategoryValue(category) || $index) {
          <p-fieldset [legend]="getCategoryValue(category) | FunctionCategory | translate">
            <div class="grid grid-cols-[repeat(auto-fit,minmax(min(100%,22rem),1fr))] gap-3">
              @for (contactFunction of category.functions; track getFunctionKey(contactFunction)) {
                <div class="grid min-w-0 grid-cols-[minmax(0,1fr)_auto] items-start gap-3">
                  <span class="min-w-0 text-sm leading-5 text-[var(--text-color)] [overflow-wrap:anywhere]">
                    {{ getFunctionDisplayName(contactFunction) }}
                  </span>
                  <p-toggleswitch
                    class="justify-self-end"
                    [ngModel]="isFunctionSelected(contactFunction)"
                    [disabled]="isSavingContactFunctions"
                    (ngModelChange)="setFunctionSelected(contactFunction, $event)">
                  </p-toggleswitch>
                </div>
              }
            </div>
          </p-fieldset>
        }
      </div>
    </div>
  }

  <ng-template #footer>
    <p-button
      [label]="'cancelButton' | translate"
      severity="secondary"
      [outlined]="true"
      [disabled]="isSavingContactFunctions"
      (onClick)="closeEditDialog()">
    </p-button>
    <p-button
      [label]="'saveButton' | translate"
      icon="pi pi-check"
      [loading]="isSavingContactFunctions"
      [disabled]="isSavingContactFunctions"
      (onClick)="saveContactFunctions()">
    </p-button>
  </ng-template>
</p-dialog>
